module.exports = __webpack_public_path__ + "img/linkedin-ic-blue.0d8bbf58.svg";